import t from '@jetshop/intl';
import React from 'react';
import { styled } from 'linaria/react';
import { css, cx } from 'linaria';
import Image from '@jetshop/ui/Image/Image';
import Badges from '@jetshop/ui/ProductList/Badges';
import { theme } from '../Theme';
import { StyledPrice } from './ProductCard';
// import { Favourite } from '../ProductList/Favourite';
import StockOrb from '../ProductPage/StockStatus/StockOrb';
import { useStockStatus } from '@jetshop/ui/Stock/StockStatusContainer';
import ProductLink from '@jetshop/ui/ProductLink';
import { Favourite } from '../ProductList/Favourite';
import { QuickBuyButton } from '../Layout/QuickBuy/QuickBuyButton';
import { Above } from '@jetshop/ui/Breakpoints';
import { usePriceDisplay } from '../../hooks/usePriceDisplay';
import { useCustomFields } from '../ProductPageNew/components/useCustomFields';
import { checkForLongDescription } from '../ProductPageNew/ProductPage';
import CustomBadges from '../ui/CustomBadges';

const wrapperStyling = css`
  position: relative;
  display: flex;
  width: 100%;
  padding: 20px 0;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;

  .product-link {
    text-decoration: none;
    color: unset;
    width: 100%;
  }

  .product-list-card {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  .productcard-information {
    margin-left: 20px;
    font-family: ${theme.fonts.primaryFontFamily};
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h3 {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: ${theme.colors.darkgrey};
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin: 0;
    }

    h4 {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: ${theme.colors.darkgrey};
      font-family: ${theme.fonts.primaryFontFamily};
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin: 0;
    }

    p {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: ${theme.colors.darkgrey};
    }
  }

  .image-wrapper {
    max-width: 185px;
    width: 100%;
    [data-flight-image-container] {
      background: ${theme.colors.lightgrey};
    }
    [data-flight-image] {
      img {
        mix-blend-mode: multiply;
        transform: translate3d(0, 0, 0);
      }
    }
  }

  .price-and-cta {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-direction: column;
    align-items: flex-end;

    .price-package-wrapper {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      .package-price-label {
        font-size: 12px;
        color: grey;
        margin-left: 5px;
      }
      p {
        margin: 0;
        font-family: ${theme.fonts.primaryFontFamily};
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: #797979;
      }
    }
  }

  ${theme.below.lg} {
    border-bottom: none;
    padding: 5px 10px;
  }
`;

const ProductSpecifications = styled('div')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  font-family: ${theme.fonts.primaryFontFamily};

  p {
    display: flex;
    margin-left: 10px;
    font-size: 14px;
    line-height: 17px;
  }

  span {
    margin-right: 4px;
    font-weight: 700;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-left: 6px;
  }
`;

const ProductListCardWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 200px;
  .productcard-information {
    max-width: 40%;
  }
  .listcard-wrapper {
    display: flex;
  }

  ${theme.below.lg} {
    flex-direction: row;
    width: 100%;
    height: 250px;
    .productcard-information {
      max-width: 50%;
      width: 100%;
    }
    .image-wrapper {
      width: 220px;
    }
  }
`;

const ButtonWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  align-items: end;
  gap: 5px;
  ${theme.below.lg} {
    width: 10%;
  }
`;

const DesktopListCard = ({
  product,
  imageAspect,
  imageSizes,
  linkProps,
  hasImages,
  noImage,
  badges,
  loadImageEagerly,
  brand,
  stockStatus
}) => {
  const { showPrice } = usePriceDisplay();
  const { Farg } = useCustomFields(product);
  const { productDescription, isLongDescription } = checkForLongDescription(
    product?.description,
    350
  );
  const saveHashOnLinkClick = e => {
    sessionStorage.setItem('targetHash', '#product-tabs');
  };

  return (
    <ProductListCardWrapper>
      <a className="product-link" product={product} {...linkProps}>
        <div className="listcard-wrapper">
          <div className="image-wrapper">
            {hasImages ? (
              <Image
                sizes={imageSizes}
                aspect={imageAspect}
                alt={product?.images[0].alt}
                src={product?.images[0].url}
                modifiedDate={product?.images[0].modifiedDate}
                badges={<CustomBadges badges={badges} />}
                critical={loadImageEagerly}
                cover
              />
            ) : (
              noImage && (
                <Image
                  className="no-image"
                  aspect={imageAspect}
                  src={noImage}
                  alt="noimage"
                  critical={loadImageEagerly}
                />
              )
            )}
          </div>
          <div className="product-list-card">
            <div className="productcard-information">
              <div>
                <header>
                  <h3>{brand[0]?.stringValue}</h3>
                  <h4 className="sub-name">{product?.name}</h4>
                  {/* <h4 className="sub-name">{product.subName || '\u00A0'}</h4> */}
                </header>
                <p
                  style={{ marginTop: '20px' }}
                  dangerouslySetInnerHTML={{
                    __html: productDescription
                  }}
                />
                {isLongDescription && (
                  <a
                    href={`${product?.primaryRoute?.path}#product-tabs`}
                    onClick={saveHashOnLinkClick}
                    style={{ fontSize: '14px' }}
                  >
                    {t('Read more')}
                  </a>
                )}
              </div>
              <div className="price-package-wrapper">
                <div>
                  {showPrice && (
                    <StyledPrice
                      hidePrice={product?.hidePrice}
                      price={product?.price}
                      previousPrice={product?.previousPrice}
                    />
                  )}
                </div>

                {/* <p>Rek: {product?.price?.incVat} Kr</p> */}
              </div>
            </div>

            <div className="price-and-cta">
              <ProductSpecifications>
                <p>
                  <span>ART. NR:</span>
                  {product?.articleNumber}
                </p>
                <p>
                  <span>EAN:</span>
                  {product?.barcode}
                </p>
                <p>
                  <span>LAGERSTATUS:</span>
                  {stockStatus?.text}
                  <StockOrb status={stockStatus?.status} />
                </p>
                {Farg && (
                  <p>
                    <span>FÄRG:</span>
                    {Farg?.value}
                  </p>
                )}
              </ProductSpecifications>

              {showPrice && (
                <ButtonWrapper>
                  <Favourite product={product} isButton={true} />
                  <QuickBuyButton product={product} />
                </ButtonWrapper>
              )}
            </div>
          </div>
        </div>
      </a>
    </ProductListCardWrapper>
  );
};

const MobileListCard = ({
  product,
  imageAspect,
  imageSizes,
  hasImages,
  noImage,
  linkProps,
  badges,
  loadImageEagerly,
  brand,
  stockStatus
}) => {
  const { showPrice } = usePriceDisplay();
  return (
    <ProductListCardWrapper>
      <ProductLink product={product} className="product-link">
        <div className="listcard-wrapper">
          <div className="image-wrapper">
            {hasImages ? (
              <Image
                sizes={imageSizes}
                aspect={imageAspect}
                alt={product?.images[0].alt}
                src={product?.images[0].url}
                modifiedDate={product?.images[0].modifiedDate}
                badges={<CustomBadges badges={badges} />}
                critical={loadImageEagerly}
                cover
              />
            ) : (
              noImage && (
                <Image
                  className="no-image"
                  aspect={imageAspect}
                  src={noImage}
                  alt="noimage"
                  critical={loadImageEagerly}
                />
              )
            )}
          </div>
          <div className="productcard-information">
            <header>
              <h3>{brand[0]?.stringValue}</h3>
              <h4 className="sub-name">{product?.name}</h4>
              {/* <h4 className="sub-name">{product.subName || '\u00A0'}</h4> */}
            </header>

            <div className="price-package-wrapper">
              {showPrice && (
                <div>
                  <StyledPrice
                    hidePrice={product?.hidePrice}
                    price={product?.price}
                    previousPrice={product?.previousPrice}
                  />
                </div>
              )}
              {/* <p>Rek: {product?.price?.incVat} Kr</p> */}
            </div>
          </div>
        </div>
      </ProductLink>
      {showPrice && (
        <ButtonWrapper>
          <QuickBuyButton product={product} icon={true} />
        </ButtonWrapper>
      )}
    </ProductListCardWrapper>
  );
};

export const ProductListCard = ({
  product,
  imageAspect = '1:1',
  imageSizes = [1 / 2, 1 / 2, 1 / 3, 1 / 4],
  forwardRef,
  as = 'li',
  children,
  className,
  loadImageEagerly = false,
  ...linkProps
}) => {
  const hasImages = product.images && product.images.length > 0;
  const noImage =
    'https://willabb2c-hansbo.jetshop.se/pub_docs/files/Hmissing.jpg';
  const Tag = as;
  let badges = [...(product.badges || [])];
  product.isPackage &&
    badges.push({
      location: 'TOP_RIGHT',
      name: 'Package',
      text: t('Package'),
      style: 'package-badge'
    });

  const brand = product?.customFields?.filter(
    customField => customField.key === 'Varumarke'
  );
  const stockStatus = useStockStatus(product);

  return (
    <Tag
      className={cx('product-card', wrapperStyling, className)}
      data-testid="product"
      data-product-card
      ref={forwardRef}
    >
      <Above breakpoint="md">
        {matches =>
          matches ? (
            <DesktopListCard
              product={product}
              linkProps={{ ...linkProps }}
              hasImages={hasImages}
              noImage={noImage}
              badges={badges}
              loadImageEagerly={loadImageEagerly}
              brand={brand}
              stockStatus={stockStatus}
            />
          ) : (
            <MobileListCard
              product={product}
              linkProps={{ ...linkProps }}
              hasImages={hasImages}
              noImage={noImage}
              badges={badges}
              loadImageEagerly={loadImageEagerly}
              brand={brand}
              stockStatus={stockStatus}
            />
          )
        }
      </Above>
    </Tag>
  );
};
